'use client'
import React from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

export interface IRadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name'> {
    name?: string
    labelText: React.ReactNode
    value: string
    register?: UseFormRegisterReturn
}

/** Opção de escolha única com o texto ao lado (padrão do orbit: `register`); id padrão `${name}-${value}`. */
const Radio: React.FC<IRadioProps> = ({ name, labelText, id, value, className, register, ...rest }) => {
    // Padrão `${grupo}-${valor}`: as opções do mesmo grupo não repetem o id, e o rótulo marca a própria opção.
    const group = name ?? register?.name
    const inputId = id || (group ? `${group}-${value}` : undefined)
    return (
        <div className={`flex form-group pb-2 items-start ${className ?? ''}`}>
            <label htmlFor={inputId} className="flex select-none items-center justify-between px-1 py-2 font-sora">
                <input
                    name={name}
                    {...register}
                    type="radio"
                    id={inputId}
                    className="h-8 w-8 cursor-pointer!"
                    value={value}
                    {...rest}
                />
                <span className="pl-4 text-base text-primary cursor-pointer!">{labelText}</span>
            </label>
        </div>
    )
}

export default Radio
